<template>
  <v-dialog v-model="dOpenComponente" persistent width="1000px" content-class="">
    <v-card>

      <!-- cabecera del dialogo -->
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{ dInformeComponente.nombre }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-dialog v-model="dLoading" hide-overlay persistent width="300">
        <v-card class="datModalTitleContainer" dark>
          <v-card-text>
            {{ $t('cargandoContenido') }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-form ref="form" lazy-validation>
        <v-card-text>

          <v-flex xs12 class="pl-2 datModalSubtitle mb-3">
            {{ dInformeComponente.descripcion }}
          </v-flex>

          <v-layout row wrap justify-space-between>
            <v-flex xs12 sm5 px-2>
              <p class="datLabelGroup">
                {{ $t('fecha') }}
              </p>
              <v-menu ref="fechaIniMenu" lazy :close-on-content-click="false" v-model="dDatosFecha.fechaIniMenu"
                transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator" :label="$t('fechaInicial')"
                  v-model="dDatosFecha.fechaIniDateString" append-icon="event" readonly
                  :rules="[rules.checkfechasVencimientos]"></v-text-field>
                <v-date-picker :min="dDatosFecha.fechaMinIni" clearable color="datSecondary"
                  v-model="dDatosFecha.fechaIniDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaIniMenu.save(dDatosFecha.fechaIniDate)">
                </v-date-picker>
              </v-menu>
              <v-menu ref="fechaFinMenu" lazy :close-on-content-click="false" v-model="dDatosFecha.fechaFinMenu"
                transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator" :label="$t('fechaFinal')"
                  v-model="dDatosFecha.fechaFinDateString" append-icon="event" readonly
                  :rules="[rules.checkfechasVencimientos]"></v-text-field>
                <v-date-picker :min="dDatosFecha.fechaMinFin" clearable color="datSecondary"
                  v-model="dDatosFecha.fechaFinDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaFinMenu.save(dDatosFecha.fechaFinDate)">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm5 px-2>
              <p class="datLabelGroup">
                {{ $t('fechaEntrega') }}
              </p>
              <v-menu ref="fechaEntIniMenu" lazy :close-on-content-click="false" v-model="dDatosFecha.fechaEntIniMenu"
                transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator" :label="$t('fechaInicialEntrega')"
                  v-model="dDatosFecha.fechaEntIniDateString" append-icon="event" readonly
                  :rules="[rules.checkfechasFacturas]"></v-text-field>
                <v-date-picker clearable color="datSecondary" v-model="dDatosFecha.fechaEntIniDate" no-title scrollable
                  :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaEntIniMenu.save(dDatosFecha.fechaEntIniDate)">
                </v-date-picker>
              </v-menu>
              <v-menu ref="fechaEntFinMenu" lazy :close-on-content-click="false" v-model="dDatosFecha.fechaEntFinMenu"
                transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator" :label="$t('fechaFinalEntrega')"
                  v-model="dDatosFecha.fechaEntFinDateString" append-icon="event" readonly
                  :rules="[rules.checkfechasFacturas]"></v-text-field>
                <v-date-picker clearable color="datSecondary" v-model="dDatosFecha.fechaEntFinDate" no-title scrollable
                  :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaEntFinMenu.save(dDatosFecha.fechaEntFinDate)">
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <!-- representantes -->
          <v-layout row wrap justify-space-between>
            <v-flex v-if="dRole !== 'CLIENTE'" xs12 sm5 px-2>
              <p class="datLabelGroup">
                {{ $t('Representante') }}
              </p>
              <DatTextFieldCodeSubfield ref="TablaDeRepresentantes" :pDataPass="dDataRepre" @select="fSelectRepre"
                @alert="fAlert" @clean="fCleanRepre"></DatTextFieldCodeSubfield>
            </v-flex>
            <v-flex v-if="dRole !== 'CLIENTE'" xs12 sm5 px-2>
              <p class="datLabelGroup">
                {{ $t('cliente') }}
              </p>
              <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient" @select="fSelectClient" @alert="fAlert"
                @clean="fCleanClient"></DatTextFieldCode>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 px-2>
              <p class="datLabelGroup">
                {{ $t('otros') }}
              </p>
            </v-flex>
            <v-flex xs12 sm4 px-2>
              <v-select color="datPrimary" :items="dInformes" :label="this.$t('tipoListado')"
                v-model="dInformeSeleccionado" item-value="codigo" item-text="nombre"></v-select>
            </v-flex>
            <v-flex xs12 sm4 px-2>
              <v-select color="datPrimary" :items="dEstados" :label="this.$t('estado')" v-model="dEstadoSeleccionado"
                item-value="codigo" item-text="nombre"></v-select>
            </v-flex>
            <v-flex xs12 sm4 px-2>
              <v-select color="datPrimary" :items="dPedidos" :label="this.$t('pedidos')" v-model="dPedidoSeleccionado"
                item-value="codigo" item-text="nombre"></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="[4, 5, 6].includes(this.dInformeSeleccionado)">
            <v-flex xs12 sm2 px-2>
              <v-text-field v-model="dNivel1Seleccionado" ref="nivel1" type="number" clearable
                :label="$t('nivel') + 1"></v-text-field>
            </v-flex>
            <v-flex xs12 sm2 px-2>
              <v-text-field v-model="dNivel2Seleccionado" ref="nivel2" type="number" clearable
                :label="$t('nivel') + 2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm4 px-2>
              <v-select color="datPrimary" :items="dTiposVenta" :label="this.$t('tipoVenta')"
                v-model="dTipoVentaSeleccionado" item-value="codigo" item-text="nombre"></v-select>
            </v-flex>
            <v-flex xs12 sm4 px-2>
              <v-select color="datPrimary" :items="dTiposOrden" :label="this.$t('orden')"
                v-model="dTipoOrdenSeleccionado" item-value="codigo" item-text="nombre"></v-select>
            </v-flex>
            <v-flex xs12 sm4 px-2>
              <v-select color="datPrimary" :items="dFamilias" :label="this.$t('familias')"
                v-model="dFamiliaSeleccionada" item-value="codigo" item-text="nombre"></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="py-3 transparent">
          <v-flex xs12 pr-3 class="text-xs-right">
            <v-btn class="datPrimaryBtnOut" flat @click="fLimpiaFiltros()">{{ this.$t('limpiar') }}</v-btn>
            <v-btn class="datPrimaryBtn" flat @click="fDescargarInforme()" :disabled="dDisableDescarga">
              {{ dDescargarTxt }}
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

import SrvImpresion from '@/services/srv-impresion'
import { generarPdf, abrirPestanaEnBlanco, abrirPdfEnPestanaPreabierta } from '@/utils/utilDescargarPdf'
import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'
import DatTextFieldCodeSubfield from '@/components_datadec/DatTextFieldCodeSubfield'

export default {
  name: 'ShpFiltroBaseInformes',
  components: {
    DatTextFieldCode,
    DatTextFieldCodeSubfield
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    },
    pLimitDate: {
      type: Object,
      required: false,
      default: {}
    }
  },
  data() {
    return {
      dFormatDate: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dEventosAviso: {
        'mostrarAviso': 'evento-mostrarAvisos'
      },
      dDescargarTxt: this.$t('descargar'),
      dDisableDescarga: false,
      dNivel1Seleccionado: 1,
      dNivel2Seleccionado: 2,
      dEstadoSeleccionado: 'S',
      dLoading: false,
      dOpenComponente: true,
      dEstados: [
        { codigo: 'E', nombre: this.$t('pendienteServir') },
        { codigo: 'S', nombre: this.$t('pendienteFacturar') },
        { codigo: 'F', nombre: this.$t('facturados') },
        { codigo: 'T', nombre: this.$t('entrados') }
      ],
      dPedidoSeleccionado: 'T',
      dPedidos: [
        { codigo: 'P', nombre: this.$t('pedidos') },
        { codigo: 'C', nombre: this.$t('cargaAbonos') },
        { codigo: 'T', nombre: this.$t('todos') }
      ],
      dTipoVentaSeleccionado: 'T',
      dTiposVenta: [
        { codigo: 'C', nombre: this.$t('contados') },
        { codigo: 'R', nombre: this.$t('creditos') },
        { codigo: 'T', nombre: this.$t('todos') }
      ],
      dTipoOrdenSeleccionado: 'A',
      dTiposOrden: [
        { codigo: 'A', nombre: this.$t('articulo') },
        { codigo: 'D', nombre: this.$t('denominacion') },
        { codigo: 'I', nombre: this.$t('importe') }
      ],
      nivelMax: this.$store.getters.getAutenticacion.nivelMaxArt || 5,
      dFamiliaSeleccionada: 5,
      dFamilias: [
        { codigo: '1', nombre: this.$t('nivel') + '1' },
        { codigo: '2', nombre: this.$t('nivel') + '2' },
        { codigo: '3', nombre: this.$t('nivel') + '3' },
        { codigo: '4', nombre: this.$t('nivel') + '4' },
        { codigo: '5', nombre: this.$t('nivel') + '5' }
      ],
      dInformeSeleccionado: 1,
      dInformes: [
        { codigo: 1, nombre: this.$t('familiaArticulo') },
        { codigo: 4, nombre: this.$t('dptoConcepto') },
        { codigo: 5, nombre: this.$t('conceptoCliente') },
        { codigo: 6, nombre: this.$t('clienteConcepto') },
        { codigo: 9, nombre: this.$t('clienteFamilia12m') },
        { codigo: 11, nombre: this.$t('familiaCliente12m') }
      ],
      dRole: '',
      dInformeComponente: null,
      dSelectClienteIni: { codigo: '', nombre: '' },
      dRequestClient: { empresa: this.$store.getters.getUrlInfo.empresa },
      dSelectRepreIni: { codigo: '', subfield: '', nombre: '' },
      dRequestRepre: { empresa: this.$store.getters.getUrlInfo.empresa, pasivo: 'N' },
      dRequestRepreSec: { empresa: this.$store.getters.getUrlInfo.empresa },
      dDatosFecha: {
        'fechaIni': '',
        'fechaIniMenu': false,
        'fechaIniDate': '',
        'fechaIniDateString': '',
        'fechaMinIni': '',
        'fechaFin': '',
        'fechaFinMenu': false,
        'fechaFinDate': '',
        'fechaFinDateString': '',
        'fechaMinFin': '',
        'fechaEntIni': '',
        'fechaEntIniMenu': false,
        'fechaEntIniDate': '',
        'fechaEntFin': '',
        'fechaEntFinMenu': false,
        'fechaEntFinDate': '',
        'fechaEntFinDateString': ''
      },
      dRowsPerPage: 5,
      dDataClient: {},
      dDataRepre: {},
      rules: {
        /*
         * Regla para comprobar fecha de creacion
         */
        checkfechasVencimientos: (value) => {
          if ((this.dDatosFecha.fechaIniDateString !== undefined) && (this.dDatosFecha.fechaFinDateString !== undefined) &&
            (this.dDatosFecha.fechaIniDateString !== null) && (this.dDatosFecha.fechaFinDateString !== null) &&
            (this.dDatosFecha.fechaIniDateString !== '') && (this.dDatosFecha.fechaFinDateString !== '')) {
            const fechaIniDate = this.$moment(this.dDatosFecha.fechaIniDateString, this.dFormatDate.default)
            const fechaFinDate = this.$moment(this.dDatosFecha.fechaFinDateString, this.dFormatDate.default)
            if (fechaIniDate <= fechaFinDate) {
              return true
            } else {
              return this.$t('fechaInicialMayorFinal')
            }
          } else {
            return true
          }
        },
        /*
         * Regla para comprobar fecha de creacion
         */
        checkfechasFacturas: (value) => {
          if ((this.dDatosFecha.fechaEntIniDateString !== undefined) && (this.dDatosFecha.fechaEntFinDateString !== undefined) &&
            (this.dDatosFecha.fechaEntIniDateString !== null) && (this.dDatosFecha.fechaEntFinDateString !== null) &&
            (this.dDatosFecha.fechaEntIniDateString !== '') && (this.dDatosFecha.fechaEntFinDateString !== '')) {
            const fechaEntIniDate = this.$moment(this.dDatosFecha.fechaEntIniDateString, this.dFormatDate.default)
            const fechaEntFinDate = this.$moment(this.dDatosFecha.fechaEntFinDateString, this.dFormatDate.default)
            if (fechaEntIniDate <= fechaEntFinDate) {
              return true
            } else {
              return this.$t('fechaInicialMayorFinal')
            }
          } else {
            return true
          }
        }
      }
    }
  },
  watch: {
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFecha.fechaIniDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFecha.fechaIniDateString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFecha.fechaFinDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFecha.fechaFinDateString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFecha.fechaEntIniDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFecha.fechaEntIniDateString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFecha.fechaEntFinDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFecha.fechaEntFinDateString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
      }
    }
  },
  created() {
    this.fLimitFechas()
    this.fIniciarVariables()
    // Inicializa las variables locales
    this.dInformeComponente = this.pInformeComponente
  },
  methods: {
    fIniciarVariables() {
      this.dRole = this.pLimitDate.roleUser
      let isRepre = false
      if (this.dRole === 'REPRESENTANTE') {
        this.dSelectRepreIni.codigo = this.$store.getters.getAutenticacion.representante
        this.dSelectRepreIni.subfield = this.$store.getters.getAutenticacion.agente
        this.dSelectRepreIni.nombre = this.$store.getters.getAutenticacion.representanteNombre
        isRepre = true
        this.dRequestRepreSec = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          representante: this.$store.getters.getAutenticacion.representante,
          agente: this.$store.getters.getAutenticacion.agente
        }
      }
      if (this.dRole === 'CLIENTE') {
        this.dSelectClienteIni.codigo = this.$store.getters.getAutenticacion.cliente
      }
      this.dDataClient = {
        'errorMessages': [],
        'label': 'clienteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovClte',
        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'cliente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'request': this.dRequestClient,
        'default': this.dSelectClienteIni,
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }
      this.dDataRepre = {
        'errorMessages': [],
        'labelMainField': 'codigo',
        'labelSubField': 'agente',
        'label': 'representanteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'representante' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'agente' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovRep',
        'headersSec': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'REP_REPRESENTANTE' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'REP_AGENTE' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'REP_NOMBRE' }
        ],
        'filtersSec': { 'codigo': 'REP_REPRESENTANTE', 'subfield': 'REP_AGENTE', 'nombre': 'REP_NOMBRE' },
        'defaultSec': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'isSec': isRepre,
        'urlSec': 'getRepres',
        'requestSec': this.dRequestRepreSec,
        'orderByDefaultSec': 'REP_REPRESENTANTE',
        'item': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'request': this.dRequestRepre,
        'filters': { 'codigo': 'representante', 'subfield': 'agente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'default': this.dSelectRepreIni,
        'disabled': false,
        'required': false,
        'title': 'selectRepresentante',
        'isVisibleLoad': true,
        'orderByDefault': 'representante',
        'orderDefault': 'ASC'
      }
      this.dFamiliaSeleccionada = this.nivelMax || 5;
      this.dFamilias = [];
      for (let index = 1; index <= this.nivelMax; index++) {
        this.dFamilias.push({ codigo: index, nombre: this.$t('nivel') + index })

      }

    },
    fSelectClient(item) {
      if (item && item != null) {
        this.dSelectClienteIni.codigo = item.codigo
        this.dSelectClienteIni.nombre = item.nombre
      }
    },
    fSelectRepre(item) {
      if (item && item != null) {
        this.dSelectRepreIni.codigo = item.codigo
        this.dSelectRepreIni.subfield = item.subfield
        this.dSelectRepreIni.nombre = item.nombre
      }
    },
    fCleanClient() {
      this.dSelectClienteIni = {}
    },
    fCleanRepre() {
      this.dSelectRepreIni = {}
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    /**
     * Metodo para cerrar la ventana
     */
    fCerrarVentana() {
      this.fLimpiaFiltros()
      this.$emit('close')
    },
    /**
     * Metodo de limpieza de los filtros
     */
    fLimpiaFiltros() {
      if (this.dRole === 'ADMIN') {
        this.dSelectRepreIni = { codigo: '', nombre: '' }
        if (this.$refs.TablaDeRepresentantes) {
          this.$refs.TablaDeRepresentantes.fActualizarItem(this.dSelectRepreIni)
        }
      }
      if (this.dRole === 'ADMIN' || this.dRole === 'REPRESENTANTE') {
        this.dSelectClienteIni = { codigo: '', nombre: '' }
        if (this.$refs.TablaDeClientes) {
          this.$refs.TablaDeClientes.fActualizarItem(this.dSelectClienteIni)
        }
      }
      this.dEstadoSeleccionado = 'S'
      this.dPedidoSeleccionado = 'T'
      this.dTipoVentaSeleccionado = 'T'
      this.dTipoOrdenSeleccionado = 'A'
      this.dFamiliaSeleccionada = this.nivelMax || 5;
      this.dInformeSeleccionado = 1
      this.dDatosFecha.fechaIni = ''
      this.dDatosFecha.fechaIniMenu = false
      this.dDatosFecha.fechaIniDate = ''
      this.dDatosFecha.fechaIniDateString = ''
      this.dDatosFecha.fechaFin = ''
      this.dDatosFecha.fechaFinMenu = false
      this.dDatosFecha.fechaFinDate = ''
      this.dDatosFecha.fechaFinDateString = ''
      this.dDatosFecha.fechaEntIni = ''
      this.dDatosFecha.fechaEntIniMenu = false
      this.dDatosFecha.fechaEntIniDate = ''
      this.dDatosFecha.fechaEntIniDateString = ''
      this.dDatosFecha.fechaEntFin = ''
      this.dDatosFecha.fechaEntFinMenu = false
      this.dDatosFecha.fechaEntFinDate = ''
      this.dDatosFecha.fechaEntFinDateString = ''
    },
    /**
     * Metodo de descarga del informes
     */
    fAssignedFilters(jsonEntrada) {
      if ((this.dSelectRepreIni !== undefined) && (this.dSelectRepreIni.codigo !== '') && (this.dSelectRepreIni.codigo !== undefined)) {
        jsonEntrada.repIni = String(this.dSelectRepreIni.codigo)
        jsonEntrada.repFin = String(this.dSelectRepreIni.codigo)
      } else {
        jsonEntrada.repIni = ''
        jsonEntrada.repFin = ''
      }
      if ((this.dSelectClienteIni !== undefined) && (this.dSelectClienteIni.codigo !== '') && (this.dSelectClienteIni.codigo !== undefined)) {
        jsonEntrada.cliIni = String(this.dSelectClienteIni.codigo)
        jsonEntrada.cliFin = String(this.dSelectClienteIni.codigo)
      } else {
        jsonEntrada.cliIni = ''
        jsonEntrada.cliFin = ''
      }
      jsonEntrada.fechaIni = (this.dDatosFecha.fechaIniDateString !== null && this.dDatosFecha.fechaIniDateString !== '') ? this.dDatosFecha.fechaIniDateString : ''
      jsonEntrada.fechaFin = (this.dDatosFecha.fechaFinDateString !== null && this.dDatosFecha.fechaFinDateString !== '') ? this.dDatosFecha.fechaFinDateString : ''
      jsonEntrada.fechaEntIni = (this.dDatosFecha.fechaEntIniDateString !== null && this.dDatosFecha.fechaEntIniDateString !== '') ? this.dDatosFecha.fechaEntIniDateString : ''
      jsonEntrada.fechaEntFin = (this.dDatosFecha.fechaEntFinDateString !== null && this.dDatosFecha.fechaEntFinDateString !== '') ? this.dDatosFecha.fechaEntFinDateString : ''
    },
    fDescargarInforme() {
      const ventanaPdf = abrirPestanaEnBlanco()
      this.dDescargarTxt = this.$t('descargar')
      this.dDisableDescarga = true
      this.dLoading = true
      // this.dDescargarTxt = this.$t('enPreparacion')
      if (this.fCheckFiltrosPendientes()) {
        this.fDescargandoInforme()
        // prepara los parametros generales de busqueda
        const jsonEntrada = {
          tira: this.$store.getters.getAutenticacion.tira,
          usuario: this.$store.getters.getAutenticacion.usuario,
          empresa: this.$store.getters.getAutenticacion.empresa,
          tipoEmpresa: '0',
          pdfSn: 'S'
        }
        this.fAssignedFilters(jsonEntrada)
        // Parametros formulario
        jsonEntrada.estadoPed = this.dEstadoSeleccionado
        jsonEntrada.tipoPedidos = this.dPedidoSeleccionado
        jsonEntrada.tipoVenta = this.dTipoVentaSeleccionado
        jsonEntrada.tipoOrden = this.dTipoOrdenSeleccionado
        jsonEntrada.tipoListado = this.dInformeSeleccionado
        jsonEntrada.nivelFamilia = this.dFamiliaSeleccionada
        if ([4, 5, 6].includes(this.dInformeSeleccionado)) {
          jsonEntrada.nivel1 = this.dNivel1Seleccionado || 1
          jsonEntrada.nivel2 = this.dNivel2Seleccionado || 2
        }

        SrvImpresion.informeSituacionExpert(jsonEntrada).then(response => {
          if (response.data.statusCode === '200') {
            if (((response.data.errorMsg === '') || (response.data.errorMsg === undefined)) && response.data.report !== '') {
              // obtiene la url y la levanta en una nueva ventana
              abrirPdfEnPestanaPreabierta(generarPdf(response.data.report), ventanaPdf)
              this.numValidacionesValue = 0
            } else {
              if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
              if (response.data.errorCode !== undefined && response.data.errorMsg !== '') {
                this.$emit('alert', '<b>' + this.$t('estadoVentaNotFound') + '</b><br> ' + response.data.errorMsg)
              } else {
                this.$emit('alert', '<b>' + this.$t('estadoVentaNotFound') + '</b><br> ' + this.$t('estadoVentaNotFoundDesc'))
              }
            }
          } else {
            if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
            this.$emit('alert', '<b>' + this.$t('estadoVentaNotFound') + '</b><br> ' + this.$t('estadoVentaNotFoundDesc'))
          }
          this.dDisableDescarga = false
          this.dLoading = false
          this.dDescargarTxt = this.$t('descargar')
        }).catch(error => {
          if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
          this.fErrorComprobado(error.response)
          this.dDisableDescarga = false
          this.dLoading = false
          this.dDescargarTxt = this.$t('descargar')
        })
      } else {
        if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
        this.dDisableDescarga = false
        this.dLoading = false
        this.$emit('alert', '<b>' + this.$t('avisoFactura') + '</b><br/>' + this.$t('avisoFacturaDesc'))
      }
    },
    fErrorComprobado(error) {
      if (error !== undefined) {
        if (error.data.statusText !== undefined) {
          this.$emit('alert', this.$t('errorDefault') + error.data.statusText + '  (' + error.data.statusCode + ' ) ')
        }
        if (error.data.exception !== undefined) {
          this.$emit('alert', this.$t('errorDefault') + error.data.exception)
        }
        if (error.data.errorMsg !== undefined) {
          this.$emit('alert', this.$t('errorDefault') + error.data.errorMsg)
        }
      }
    },
    /*
     * Metodo de descargando
     */
    fDescargandoInforme() {
      this.dDisableDescarga = true
      this.dDescargarTxt = this.$t('enPreparacion')
    },
    /**
     * comprueba si falta recibir información de algun filtro
     */
    fCheckFiltrosPendientes() {
      return ((this.dSelectRepreIni !== undefined) && (this.dSelectRepreIni.codigo !== '') && (this.dSelectRepreIni.codigo !== undefined)) ||
        ((this.dSelectClienteIni !== undefined) && (this.dSelectClienteIni.codigo !== '') && (this.dSelectClienteIni.codigo !== undefined))
    },
    fLimitFechas() {
      if (this.pLimitDate.fechaIniLimit !== '' && this.pLimitDate.fechaIniLimit !== null) {
        this.dFechaMinIni = this.$moment(this.pLimitDate.fechaIniLimit, this.dFormatDate.years).format(this.dFormatDate.years)
      }
      if (this.pLimitDate.fechaFinLimit !== '' && this.pLimitDate.fechaFinLimit !== null) {
        this.dFechaMinFin = this.$moment(this.pLimitDate.fechaFinLimit, this.dFormatDate.years).format(this.dFormatDate.years)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.buttonBar .card__title {
  padding: 8px !important;
}

.buttonBarSearch .card__title {
  padding: 0px !important;
}

.buttonBarSearchTop .card__text {
  padding-top: 4px !important;
  padding-bottom: -10px !important;
}

.numberInputSpinnerInput .vnis__input {
  background: #ffffff !important;
  border: 0px !important;
  border-bottom: 1px solid #999999 !important;
}

.numberInputSpinnerButton .vnis__button {
  background: #ffffff !important;
  color: #000000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/Pedidos/ShpFiltroEstadoVentas.vue